<ion-popover #popoverDatetime [trigger]="'trigger_'+this.formName" side="bottom" alignment="center">
    <ng-template>    
        <ion-label>{{this.labelInput}}</ion-label>
        <ion-datetime #datetime 
            presentation="date" 
            show-adjacent-days="true"
            [firstDayOfWeek]="1"
            value="{{this.formGroupDirective.form.controls[this.formName].value | marvDateToString: 'ISO8601'}}" 
            [min]="this.minDate"
            [max]="this.maxDate"
            [isDateEnabled]="this.isDateEnabled"
            [highlightedDates]="this.highlightedDates"
            (ionChange)="this.selectDate($event)"
            >
            <ion-buttons slot="buttons">                
                <ion-button color="primary" fill="clear" (click)="datetime.confirm()">{{'VALIDATE' | translate}}</ion-button>
                <ion-button color="primary" fill="clear" (click)="this.closeDatePicker()">{{'CANCEL' | translate}}</ion-button>
            </ion-buttons>
        </ion-datetime>
    </ng-template>
</ion-popover>

<div 
    class="marv_input_date"
    [class.no_margin]="this.noMargin" 
    [class.disabled]="this.disabled"   
    >
    
    <div class="marv_input_date_trigger" [id]="(!this.disabled ? 'trigger_'+this.formName : '')">                
        @if(this.withSpeechToText){
            <ion-icon class="marv_input_icon_speech" name="mic-outline" (click)="this.speechToText($event)"></ion-icon>
        }        
    </div>
    
    @if(this.iconInput !== ''){
        <ion-icon class="marv_input_date_icon_prefix" [name]="this.iconInput"></ion-icon>
    }
    
    @if(this.isRequired){
        <div class="marv_input_required">*</div>
    }
    
    @if(this.fixedLabel){
        <div class="marv_input_fixed_label">{{this.labelInput}}</div>
    }
    
    <input 
        type="text" 
        [placeholder]="(!this.fixedLabel ? this.labelInput : '')"          
        autocomplete="off"
        value="{{this.formGroupDirective.form.controls[this.formName].value | marvDateToString}}"        
        disabled
        />    
        
    <input type="hidden" [name]="this.formName" [formControlName]="this.formName" />    
</div>

@if(this.errorText !== '' 
    && this.formGroupDirective.form.controls[this.formName] 
    && this.formGroupDirective.form.controls[this.formName].touched 
    && this.formGroupDirective.form.controls[this.formName].errors){
    <div class="marv_input_error">{{this.errorText}}</div>
}

@if(this.withSpeechToText){
    <marv-speech-to-text #marvSpeechToText (onDidDismiss)="this.onDismissSpeechToText($event)"/>
}